const Colors = Object.freeze({
  RED: "#FF0000",
  YELLOW: "#FFFF00",
  BLUE: "#0000FF",
  BLACK: "#000000",
  WHITE: "#FFFFFF"
});

export default Colors;
